<p-sidebar
  [showCloseIcon]="false"
  styleClass="side-bar"
  [(visible)]="visibleSidebar"
  [baseZIndex]="10000"
>

  <p-tieredMenu
    [style]="{ top: '-20px' }"
    styleClass="relative w-full h-full p-0 side-menu"
    [model]="menuItensSideMenu"
  ></p-tieredMenu>

  <ng-template pTemplate="footer">{{version}}</ng-template>
</p-sidebar>
<div class="flex justify-content-between layout-topbar">
  <div class="flex justify-content-between align-items-center">
    <img
      [style]="{ height: '3rem' }"
      (click)="goToSelectApp()"
      style="cursor: pointer;"
      src="/assets/images/logo-white.png"
      alt="logo"/>
    <p-button
      *ngIf="!checkForceChangePassword()"
      icon="pi pi-bars"
      [rounded]="true"
      [text]="true"
      severity="secondary"
      class="ml-5"
      [style]="{ 'color': '#DADCDF' }"
      (onClick)="visibleSidebar = true"
    ></p-button>
    <img
      *ngIf="showNotixPixel" alt="NOTIX"
      ngSrc="https://notix.io/mt.gif?user={{ email }}&app_id={{ notixAppId }}"
      width="1"
      height="1"
    />
  </div>
  <div class="flex align-items-center" #divOverlayMenu>
    <button
    *ngIf="userService.hasPermission([role.ADMIN_FULL, role.GESTOR, role.EQUIPMENT_ALERT])"
    class="gradient-animated mr-3"
    [class.is-blinking]="alertBlinking"
    (click)="opAlert.toggle($event)">
      <i class="fa-solid fa-bell"></i>
      <span class="font-bold">Alertas</span>
      <span *ngIf="badgeCount > 0" class="notification-badge">{{ badgeCount }}</span>
    </button>
    <p-button label="Nexus"
              (onClick)="goToSelectApp()"
              class="alert-btn mr-2">
      <img width="35" height="30"
           src="assets/images/velsinho/Pose%205%20com%20sombra.png">
    </p-button>
    <i class="pi pi-users text-2xl mr-5 mt-1" pBadge
       pTooltip="Usuários online" tooltipPosition="bottom"
       style="cursor: pointer;"
       (click)="showUsuariosLogados()"
       *ngIf="userService.hasPermission([role.ADMIN_FULL, role.GESTOR])"
       [severity]="possueUsuariosLogados > 0 ? 'success' : 'info'"
       [value]="possueUsuariosLogados + ''"></i>
    <i class="pi pi-spin pi-spinner text-2xl"
       style="margin-right: 1rem;"
       *ngIf="!showReservadasIcon && themeService.showFrameworkMenu && userService.hasPermission([role.ADMIN_FULL, role.GESTOR, role.PROCESSAMENTO_TRIAGEM])"
    ></i>
    <i class="pi pi-spin pi-spinner text-2xl"
       style="margin-right: 1rem;"
       *ngIf="!showReservadasPassagemIcon && themeService.showFrameworkMenu && userService.hasPermission([role.ADMIN_FULL, role.GESTOR, role.PROCESSAMENTO_TRIAGEM])"
    ></i>
    <!-- TO OD - RESOLVER ESSE BO -->
    <ng-container *ngIf="{ totalReservadas: ((triagemService | totalReservadas) | async) ?? 0 } as vm">
      <ng-container *ngIf="showReservadasIcon && userService.hasPermission([role.ADMIN_FULL, role.GESTOR, role.PROCESSAMENTO_TRIAGEM])">
        <i class="fa-solid fa-file-shield text-2xl" severity="warning"
           pBadge [value]="vm.totalReservadas + ''"
           [badgeDisabled]="vm.totalReservadas === 0"
           style="cursor: pointer; margin-right: 1rem;"
           [pTooltip]="vm.totalReservadas > 0 ? 'Você possui imagens reservadas para processar' : 'Você não possui imagens reservadas para processar'"
           (click)="setMenuOptionsTriagem(); opMenu.toggle($event);">
        </i>
          <!-- TO DO - DESCOMENTAR QUANDO SUBIR PASSAGEM P/ PROD -->
        <!-- <i class="fa-solid fa-road text-2xl" severity="warning"
           pBadge [value]="(triagemPassagemService | totalReservadasPassagem) + ''"
           [badgeDisabled]="(triagemPassagemService | totalReservadasPassagem) === 0"
           style="cursor: pointer; margin-right: 1rem;"
           [pTooltip]="(triagemPassagemService | totalReservadasPassagem) > 0 ? 'Você possui passagens reservadas para processar' : 'Você não possui passagens reservadas para processar'"
           *ngIf="showReservadasPassagemIcon && userService.hasPermission([role.ADMIN_FULL, role.GESTOR, role.PROCESSAMENTO_TRIAGEM])"
           (click)="setMenuOptionsTriagemPassagem(); opMenu.toggle($event);">
        </i> -->
      </ng-container>
    </ng-container>

    <p-button (onClick)="menuOptions = userMenuActions; opMenu.toggle($event);" iconPos="right"
              [icon]="menuOptions === userMenuActions && menu.visible ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
              [text]="true" size="small" [label]="userName | titlecase" [style]="{ 'color': '#DADCDF' }">
              <small class="font-normal mr-2" *ngIf="contratoSelecionado">
                ({{contratoSelecionado.name}})
              </small>
      <p-avatar icon="pi pi-user" styleClass="mr-2" shape="circle"
                [style]="{'background-color':'rgb(30 118 189)', 'color': '#ffffff'}"></p-avatar>
    </p-button>

  </div>
</div>
<p-toast key="toastMenuHeader"></p-toast>
<p-confirmDialog key="headerMenuConfirmDialog"></p-confirmDialog>
<div
  *ngIf="menuOverlayVisible"
  class="overlay-menu-mask"
  (click)="overlayPanel.hide()">
</div>
<p-overlayPanel
  #opMenu
  styleClass="overlay__menu-header"
  [baseZIndex]="11000"
  (onShow)="menuOverlayVisible = true"
  (onHide)="menuOverlayVisible = false">
  <span class="p-float-label w-full md:w-56">
    <p-dropdown [(ngModel)]="contratoSelecionado" inputId="on_label"
                (onChange)="opMenu.toggle($event); handleContratoChange($event)"
                [options]="contratoOptions" styleClass="w-full" />
  </span>
  <p-menu #menu [model]="menuOptions"
          styleClass="menu__reservadas"
          id="menu_header"></p-menu>
</p-overlayPanel>
<p-overlayPanel
  #opAlert
  styleClass="overlay__menu-header p-0 w-22rem border-none shadow-5 border-round-2xl bg-transparent"
  (onShow)="onAlertPanelShow()"
  (onHide)="onAlertPanelHide()"
>
  <ng-template pTemplate="content">
    <div class="alert-overlay max-w-22rem p-3 border-round-2xl">
      <div class="flex justify-content-between align-items-center mb-2">
        <h3 class="font-semibold text-base text-white m-0">
          Alertas Recentes
        </h3>
        <p-badge
          [value]="alerts.length"
          severity="danger"
          styleClass="bg-red-500 text-white"
        ></p-badge>
      </div>

      <div *ngIf="alerts.length; else noAlerts" class="alert-list overflow-y-auto pr-1 max-h-22rem">
        <div
          *ngFor="let alert of alerts"
          class="alert-card border-round-md"
        >
          <div class="flex justify-content-between align-items-start">
            <div class="flex align-items-center gap-2">
              <i
                class="pi"
                [ngClass]="{
                  'pi-times-circle': alert.severity === equipmentAlertSeverity.HIGH,
                  'pi-exclamation-triangle': alert.severity === equipmentAlertSeverity.MEDIUM,
                  'pi-info-circle': alert.severity === equipmentAlertSeverity.LOW
                }"
                [ngStyle]="{
                  color:
                    alert.severity === equipmentAlertSeverity.HIGH
                      ? '#f87171'
                      : alert.severity === equipmentAlertSeverity.MEDIUM
                      ? '#fbbf24'
                      : '#60a5fa'
                }"
              ></i>
              <span class="font-semibold text-sm text-white">{{
                alert.equipment
              }}</span>
            </div>

            <span
              class="text-xs font-medium border-round-md px-2 py-1"
              [ngStyle]="{
                background:
                  alert.severity === equipmentAlertSeverity.HIGH
                    ? 'rgba(248, 113, 113, 0.15)'
                    : alert.severity === equipmentAlertSeverity.MEDIUM
                    ? 'rgba(251, 191, 36, 0.15)'
                    : 'rgba(96, 165, 250, 0.15)',
                color:
                  alert.severity === equipmentAlertSeverity.HIGH
                    ? '#f87171'
                    : alert.severity === equipmentAlertSeverity.MEDIUM
                    ? '#fbbf24'
                    : '#60a5fa'
              }"
              >{{ getAlertSeverity(alert.severity) | titlecase }}</span
            >
          </div>

          <div class="text-sm text-white-alpha-80 mt-2 line-height-3">
            {{ alert.alertType | equipmentAlertTypeName}}
          </div>

          <div
            class="flex justify-content-between align-items-center mt-2 text-xs text-white-alpha-60"
          >
            <span>{{ alert.alertTimestamp | date: 'dd/MM/yyyy HH:mm:ss' }}</span>

            <a
              href="javascript:void(0)"
              (click)="viewAlert(alert)"
              class="text-sm flex align-items-center gap-1 font-medium"
              style="color: #8df7ff; opacity: 0.9"
              onmouseover="this.style.opacity='1'"
              onmouseout="this.style.opacity='0.9'"
            >
              <i class="pi pi-search text-xs"></i>
              Ver detalhes
            </a>
          </div>
        </div>
      </div>

      <ng-template #noAlerts>
        <div class="text-center text-white-alpha-70 text-sm p-3">
          Nenhum alerta recente.
        </div>
      </ng-template>

      <div
        class="text-center mt-3 border-top-1"
        style="border-color: rgba(255,255,255,0.15)"
      >
        <a
          href="javascript:void(0)"
          (click)="viewAllAlerts()"
          class="text-sm flex justify-content-center align-items-center gap-2 font-medium mt-2"
          style="color: #93c5fd; opacity: 0.85"
          onmouseover="this.style.opacity='1'"
          onmouseout="this.style.opacity='0.85'"
        >
          <i class="pi pi-list text-xs"></i>
          Ver todos os alertas
        </a>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>
<p-sidebar [(visible)]="showSidebarUsuariosLogados"
           [showCloseIcon]="false"
           position="right">
  <div class="mt-4 mb-2">
    <span class="p-float-label">
      <p-dropdown
        [options]="contratoUsuarioOptions"
        [(ngModel)]="contratoUsuariosSelecionado"
        [style]="{ width: '100%' }"
        [filter]="true"
        [disabled]="!contratoUsuarioOptions || contratoUsuarioOptions.length < 2"
        [showClear]="false"
        inputId="filterContrato"
        [placeholder]="'Selecione um contrato'"
      ></p-dropdown>
      <label htmlFor="filterContrato">Contrato (obrigatório)</label>
    </span>
  </div>
  <ul class="list-none" style="padding: 0 !important;">
    <li *ngFor="let usuario of usuariosDaSessao.get(contratoUsuariosSelecionado ?? {})">
      <a pRipple
         style="cursor: default;"
         class="p-ripple p-element flex align-items-center cursor-pointer p-3 hover:surface-100 border-round transition-colors transition-duration-150">
        <i class="pi pi-user mr-2 text-700"></i>
        <span class="font-medium text-700">{{usuario?.user}}</span>
        <span class="p-ink" style="height: 304px; width: 304px; top: -128px; left: -6px;"></span>
      </a>
    </li>

    <li *ngIf="usuariosDaSessao.get(contratoUsuariosSelecionado ?? {})?.length === 0">
      <a pRipple
         style="cursor: default;"
         class="p-ripple p-element flex align-items-center cursor-pointer p-3 hover:surface-100 border-round transition-colors transition-duration-150">
        <i class="pi pi-user-minus mr-2 text-700"></i>
        <span class="font-medium text-700">Nenhum usuário logado</span>
        <span class="p-ink" style="height: 304px; width: 304px; top: -128px; left: -6px;"></span>
      </a>
    </li>
  </ul>
</p-sidebar>
